<template>
  <div class="container">
    <span class="title is-3">{{ empresa.nombrec }}</span>
    <small class="title is-5"
      >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
    >
    <small class="subtitle is-7">{{ empresa.nombre }}</small>
    <hr />
    <div class="field is-grouped">
      <p class="control">
        <button class="button is-light" v-on:click="showList()">
          <span class="icon is-small">
            <span class="material-icons">list</span>
          </span>
          <span>Lista</span>
        </button>
      </p>
      <p class="control">
        <button class="button is-light" v-on:click="showCreateForm()">
          <span class="icon is-small">
            <span class="material-icons">add_circle_outline</span>
          </span>
          <span>Crear</span>
        </button>
      </p>
      <div class="control">
        <div class="tags has-addons">
          <span class="tag is-medium has-background-grey-lighter"
            >Total Vendedores</span
          >
          <span class="tag is-info is-medium">{{ listSeller.length }}</span>
        </div>
      </div>
    </div>
    <div>
      <p class="title">{{ title }}</p>
      <div
        class="table-container"
        v-if="statebutton == 'ver_lista' && editable == false"
      >
        <table class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>#</th>
              <th>Identificación</th>
              <th>Nombre</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-for="(seller, index) in listSeller" :key="index">
            <tr>
              <th>{{ index + 1 }}</th>
              <th>{{ seller.codigo }}</th>
              <td style="display: flex; justify-content: space-between">
                {{ seller.nombre }}
              </td>
              <td>
                <span
                  class="icon has-text-info hand"
                  @click="selectCCosto(seller)"
                >
                  <i class="material-icons">edit</i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="columns" v-if="statebutton == 'crear' && editable == false">
        <div class="column">
          <p class="title is-5">Identificación</p>
          <div>
            <input
              v-model="codigo"
              class="input"
              type="text"
              placeholder="Identificación"
            />
          </div>
        </div>
        <div class="column">
          <p class="title is-5">Nombre</p>
          <div>
            <input
              v-model="nombre"
              class="input"
              type="text"
              placeholder="Nombre"
            />
          </div>
        </div>
      </div>
      <div class="columns" v-if="statebutton == 'crear' && editable == false">
        <div class="column">
          <div class="buttons" style="margin-top: 16px">
            <button @click="saveSeller" class="button is-info is-medium">
              <span class="icon">
                <span class="material-icons">save</span>
              </span>
              <span>Guardar</span>
            </button>
            <button class="button is-medium" v-on:click="showList()">
              <span class="icon">
                <span class="material-icons">cancel</span>
              </span>
              <span>Cancelar</span>
            </button>
          </div>
        </div>
      </div>
      <div v-show="editable == true" class="columns">
        <div class="column">
          <p class="title is-5">Código: {{ editCode }}</p>
          <div>
            <input
              v-model="dataToEditSeller.codigo"
              name="input-edit-code"
              id="input-edit-code"
              class="input is-medium"
              type="text"
              placeholder="Identificación"
            />
          </div>
        </div>
        <div class="column">
          <p class="title is-5">Nombre: {{ editName }}</p>
          <div>
            <input
              v-model="dataToEditSeller.nombre"
              class="input is-medium"
              type="text"
              placeholder="Nuevo nombre"
            />
          </div>
        </div>
      </div>
      <div v-show="editable == true" class="columns">
        <div class="column">
          <div class="buttons" style="margin-top: 16px">
            <button class="button is-medium is-info" v-on:click="saveChange">
              <span class="icon">
                <span class="material-icons">edit</span>
              </span>
              <span>Editar</span>
            </button>
            <button class="button is-medium" v-on:click="cancelEdit()">
              <span class="icon">
                <span class="material-icons">cancel</span>
              </span>
              <span>Cancelar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      listSeller:[],
      codigo: "",
      nombre: "",
      title: "Vendedores",
      statebutton: "ver_lista",
      editable: false,
      editCode: "",
      editName: "",
      dataToEditSeller: {
        nombre: "",
        codigo: "",
        _id: "",
      },
      showEditSeller: false,
      codes: [],
    };
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    saveSeller() {
      let found;
      this.listSeller.forEach((ele) => {
        this.codes.push(ele.codigo);
      });
      if (this.codigo && this.nombre) {
        found = this.codes.includes(this.codigo);
        if (found === true) {
          this.$store.dispatch("notify", {
            message: "El Código del vendedor ya existe",
            type: "is-warning",
            position: "top-center",
          });
        }
        if (!found) {
          this.title = "Vendedores";
          this.statebutton = "ver_lista";
          this.createSeller(this);
        }
      } else {
        this.$store.dispatch("notify", {
          message: "Debe diligenciar todos los campos.",
          type: "is-warning",
          position: "top-center",
        });
      }
    },
    async createSeller(_this) {
      try {
        const data = {
          nombre: this.nombre,
          codigo: this.codigo,
        };
        let result;
        result = await apiServices.post(`/createseller`, data);
        this.listSeller.push(result.data);
        this.$store.dispatch("notify", {
          message: "Perfecto!. Vendedor creado.",
        });
        this.nombre = "";
        this.codigo = "";
      } catch (err) {
        console.log(err);
      }
    },
    showCreateForm() {
      this.title = "Crear Vendedor";
      this.statebutton = "crear";
      this.editable = false;
      this.hoverEdit = false;
    },
    showList() {
      this.title = "Vendedores";
      this.statebutton = "ver_lista";
      this.editable = false;
    },
    selectCCosto(seller) {
      this.showEditSellers();
      this.dataToEditSeller.codigo = seller.codigo;
      this.dataToEditSeller._id = seller._id;
      this.dataToEditSeller.nombre = seller.nombre;
      this.editable = true;
    },
    showEditSellers() {
      if (this.showEditSeller) {
        this.showEditSeller = false;

        this.statebutton = "ver_lista";
      } else {
        this.showEditSeller = true;
      }
    },
    saveChange() {
      if (this.dataToEditSeller.nombre && this.dataToEditSeller.codigo) {
        this.editSeller(this, this.dataToEditSeller);
        this.editable = false;
        this.dataToEditSeller = {
          nombre: "",
          codigo: "",
          _id: "",
        };
      } else {
        this.$store.dispatch("notify", {
          message: "Debe diligenciar todos los campos.",
          type: "is-warning",
          position: "top-center",
        });
      }
    },
    cancelEdit() {
      this.title = "Vendedor";
      this.editable = false;
      this.statebutton = "ver_lista";
    },
    async editSeller(_this, seller) {
      try {
        let result;
        result = await apiServices.post(`/editseller`, seller);
        if (result.data && result.data.message) {
          this.$store.dispatch("notify", {
            message: "El código ya se encuentra en la base de datos.",
            type: "is-danger",
            position: "top-center",
          });
        } else {
          this.dataToEditSeller = {
            nombre: "",
            codigo: "",
            _id: "",
          };
          this.listSeller.forEach(function (k) {
            if (k._id === result.data._id) {
              k.nombre = result.data.nombre;
              k.codigo = result.data.codigo;
            }
          });
          this.$store.dispatch("notify", {
            message: "Perfecto!. Vendedor editado con éxito.",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getSeller() {
      try {
        const result = await apiServices.get(`/listSellers`);
        this.listSeller = result.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.getSeller();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/configurations/seller/Seller.vue